var m = require('mithril');

module.exports = {

    view: ({ children }) => {

        return m('.table', children)

    }

}


// WEBPACK FOOTER //
// ./js/components/Table.js